import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { getFxEnabledRoles } from 'common/utils/user';

export const routes = [
    {
        component: lazy(() => import('module/sponsor/SponsorListPage')),
        permissions: ['Sponsor_Read', 'Sponsor_Create', 'Sponsor_Edit', 'Sponsor_Delete'],
        role: [
            BaseRoles.AdminId,
            BaseRoles.UserId,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.AdminReadOnly,
            ...getFxEnabledRoles(),
        ],
        path: '/',
    },
];
